import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { createTransformer } from 'mobx-utils';
import type { DynamicLabelResponse } from 'tm3-core/api.dtos';

class DynamicLabelStore extends CacheStore<DynamicLabelResponse> {
  constructor() {
    super('dynamiclabels');
  }

  /* tslint:disable-next-line:member-ordering */
  GetLabel = createTransformer((lookupName: string) => {
    const res = this.All.find((x) => x.id === lookupName);
    return res;
  });

  /* tslint:disable-next-line:member-ordering */
  UpdateLabel = createTransformer((list: LabelItem[]) => {
    if (list) {
      list.forEach((label: LabelItem) => {
        let res = this.GetLabel(label.id);
        if (res && res.hasOwnProperty('id') && label.id === res.id) {
          res.text = label.text;
        } else return;
      });
    }
  });
}

export default DynamicLabelStore;
